module.exports = __webpack_public_path__ + "media/images/favicon-c7a1031650910a0d3d4ab3fca16bbbf3.png";